import i18n from 'i18next';

const RECORD_STATUS = Object.freeze({
  IN: 'IN',
  OUT: 'OUT',
});

const RECORD_TYPE = Object.freeze({
  ABSENCE: 'ABSENCE',
  BENEFIT: 'BENEFIT',
  BREAK: 'BREAK',
  BREAK_COFFEE: 'BREAK_COFFEE',
  BREAK_MEAL: 'BREAK_MEAL',
  ITEM: 'ITEM',
  RIDE: 'RIDE',
  SHIFT: 'SHIFT',
  WORK: 'WORK',
  PROJECTWORK: 'PROJECTWORK',
  ABSENCE_SICK_LEAVE: 'ABSENCE_SICK_LEAVE',
  ABSENCE_VACATION_PAID: 'ABSENCE_VACATION_PAID',
});

const BUSINESS_TYPE = Object.freeze({
  CUSTOMER: 'CUSTOMER',
  EMPLOYER: 'EMPLOYER',
  OWNER: 'OWNER',
  RENTAL_EMPLOYER: 'RENTAL_EMPLOYER',
  SUBCONTRACTOR: 'SUBCONTRACTOR',
  NORMAL: 'NORMAL',
  FOLDER: 'FOLDER',
});

const EMPLOYMENT_TYPE = Object.freeze({
  EMPLOYEE: 'EMPLOYEE',
  PRACTITIONER: 'PRACTITIONER',
  RENTAL_EMPLOYEE: 'RENTAL_EMPLOYEE',
  TRAINEE: 'TRAINEE',
});

const FILEPERMISSION_TYPE = Object.freeze({
  FILE: 'FILE',
  FOLDER: 'FOLDER',
});

const ISO_8601_FORMAT = Object.freeze({
  DATE: 'YYYY-MM-DD',
});

const FILEPERMISSION_STATIC_FOLDER = Object.freeze({
  IMAGES: 'images',
  DOCUMENTS: 'documents',
  REPORTS: 'reports',
});

const TAXNUMBER_STATUS = Object.freeze({
  UNCHECKED: 'UNCHECKED', // If taxnumber service is down
  INVALID: 'INVALID', // If taxnumber is invalid by taxnumber check service
  VALID: 'VALID', // If taxnumber is valid by taxnumber check service
});

const DEFAULT_ADDITIONAL_SALARY_TYPES = {
  FULL_DAILY_ALLOWANCE: {
    salaryName: 'report.salaries.full_daily_allowance',
    salaryType: 'FULL_DAILY_ALLOWANCE',
    procountorSalaryCode: '4010',
    fennoaSalaryCode: '331',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  DAILY_ALLOWANCE_HALF_DAY: {
    salaryName: 'report.salaries.daily_allowance_half_day',
    salaryType: 'DAILY_ALLOWANCE_HALF_DAY',
    procountorSalaryCode: '4020',
    fennoaSalaryCode: '',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  KILOMETER_ALLOWANCE: {
    salaryName: 'report.salaries.kilometer_allowance',
    salaryType: 'KILOMETER_ALLOWANCE',
    procountorSalaryCode: '4050',
    fennoaSalaryCode: '209',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  TRAVEL_EXPENSE_COMPENSATION: {
    salaryName: 'report.salaries.travel_expense_compensation',
    salaryType: 'TRAVEL_EXPENSE_COMPENSATION',
    procountorSalaryCode: '4060',
    fennoaSalaryCode: '',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  SICK_LEAVE: {
    salaryName: 'report.salaries.sick_leave_pay',
    salaryType: 'SICK_LEAVE',
    procountorSalaryCode: '2410',
    fennoaSalaryCode: '201101',
    unit: 'report.pieces',
    baseType: 'ABSENCE',
  },
  HOLIDAY_PAY: {
    salaryName: 'report.salaries.holiday_pay',
    salaryType: 'HOLIDAY_PAY',
    procountorSalaryCode: '2201',
    fennoaSalaryCode: '',
    unit: 'report.pieces',
    baseType: 'ABSENCE',
  },
  TAXABLE_REIMBURSEMENT_OF_EXPENSES: {
    salaryName: 'report.salaries.taxable_reimbursement_of_expenses',
    salaryType: 'TAXABLE_REIMBURSEMENT_OF_EXPENSES',
    procountorSalaryCode: '2671',
    fennoaSalaryCode: '',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  WORKING_HOUR_REDUCTION_COMPENSATION: {
    salaryName: 'report.salaries.working_hour_reduction_compensation',
    salaryType: 'WORKING_HOUR_REDUCTION_COMPENSATION',
    procountorSalaryCode: '1459',
    fennoaSalaryCode: '225',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  MEAL_ALLOWANCE: {
    salaryName: 'report.salaries.meal_allowance',
    salaryType: 'MEAL_ALLOWANCE',
    procountorSalaryCode: '4030',
    fennoaSalaryCode: '303',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  TRAVEL_HOUR: {
    salaryName: 'report.salaries.travel_hour',
    salaryType: 'TRAVEL_HOUR',
    unit: 'report.pieces',
    baseType: 'RECORD_ALLOWANCE',
  },
  ADDITIONAL_WORK_HOUR: {
    salaryName: 'report.salaries.additional_work_hour',
    salaryType: 'ADDITIONAL_WORK_HOUR',
    unit: 'report.hours',
    procountorSalaryCode: '1201',
    baseType: 'RECORD_ALLOWANCE',
  },
  CONTRACT_WORK_HOUR: {
    salaryName: 'report.salaries.contract_work_hour',
    salaryType: 'CONTRACT_WORK_HOUR',
    unit: 'report.hours',
    procountorSalaryCode: '',
    baseType: 'RECORD_ALLOWANCE',
  },
  CONTRACT_PAY: {
    salaryName: 'report.salaries.contract_pay',
    salaryType: 'CONTRACT_PAY',
    unit: 'report.euro',
    procountorSalaryCode: '',
    baseType: 'RECORD_ALLOWANCE',
  },
  NATIONAL_HOLIDAY_COMPENSATION: {
    salaryName: 'report.salaries.national_holiday_compensation',
    salaryType: 'NATIONAL_HOLIDAY_COMPENSATION',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    baseType: 'RECORD_ALLOWANCE',
  },
  SUNDAY_WORK_COMPENSATION: {
    salaryName: 'report.salaries.sunday_work_compensation',
    salaryType: 'SUNDAY_WORK_COMPENSATION',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    baseType: 'RECORD_ALLOWANCE',
  },
  CHILD_CARE_LEAVE: {
    salaryName: 'report.salaries.child_care_leave',
    salaryType: 'CHILD_CARE_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  MILITARY_REFRESHER_WAGE: {
    salaryName: 'report.salaries.military_refresher_wage',
    salaryType: 'MILITARY_REFRESHER_WAGE',
    unit: 'report.pieces',
    procountorSalaryCode: '2320',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  MILITARY_SERVICE: {
    salaryName: 'report.salaries.military_service',
    salaryType: 'MILITARY_SERVICE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  PARENTAL_LEAVE: {
    salaryName: 'report.salaries.parental_leave',
    salaryType: 'PARENTAL_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '2472',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  HOLIDAY_BONUS_LEAVE: {
    salaryName: 'report.salaries.holiday_bonus_leave',
    salaryType: 'HOLIDAY_BONUS_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '2205',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  STRIKE: {
    salaryName: 'report.salaries.strike',
    salaryType: 'STRIKE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  TEMPORARY_LAY_OFF: {
    salaryName: 'report.salaries.temporary_lay_off',
    salaryType: 'TEMPORARY_LAY_OFF',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    payment: 'UNPAID',
    baseType: 'ABSENCE',
  },
  STUDY_LEAVE: {
    salaryName: 'report.salaries.study_leave',
    salaryType: 'STUDY_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    payment: 'UNPAID',
    baseType: 'ABSENCE',
  },
  INJURY_LEAVE: {
    salaryName: 'report.salaries.injury_leave',
    salaryType: 'INJURY_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '2412',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  TEMPORARY_CHILD_CARE_LEAVE: {
    salaryName: 'report.salaries.temporary_child_care_leave',
    salaryType: 'TEMPORARY_CHILD_CARE_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '2460',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  HOLIDAY_UNPAID: {
    salaryName: 'report.salaries.holiday_unpaid',
    salaryType: 'HOLIDAY_UNPAID',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  OTHER_PAID_LEAVE: {
    salaryName: 'report.salaries.other_paid_leave',
    salaryType: 'OTHER_PAID_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '2331',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  OTHER_UNPAID_LEAVE: {
    salaryName: 'report.salaries.other_unpaid_leave',
    salaryType: 'OTHER_UNPAID_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  OVERTIME_LEAVE: {
    salaryName: 'report.salaries.overtime_leave',
    salaryType: 'OVERTIME_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  RIDE: {
    salaryName: 'report.salaries.ride',
    salaryType: 'RIDE',
    unit: 'report.hours',
    baseType: 'RECORD_ALLOWANCE',
  },
  WORKING_HOUR_REDUCTION_LEAVE: {
    salaryName: 'report.salaries.working_hour_reduction_leave',
    salaryType: 'WORKING_HOUR_REDUCTION_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
  PUBLIC_HOLIDAY_LEAVE: {
    salaryName: 'report.salaries.public_holiday_leave',
    salaryType: 'PUBLIC_HOLIDAY_LEAVE',
    unit: 'report.pieces',
    procountorSalaryCode: '',
    fennoaSalaryCode: '',
    baseType: 'ABSENCE',
  },
};

export {
  RECORD_STATUS,
  RECORD_TYPE,
  ISO_8601_FORMAT,
  BUSINESS_TYPE,
  EMPLOYMENT_TYPE,
  FILEPERMISSION_TYPE,
  TAXNUMBER_STATUS,
  FILEPERMISSION_STATIC_FOLDER,
  DEFAULT_ADDITIONAL_SALARY_TYPES,
};
